<template>
  <el-row style="width: 100%;height: 100%">
    <el-col :span="12">
      <FrameQuery component-param="sys_msg_receive" @current-change="rowChange"></FrameQuery>
    </el-col>

    <el-col :span="12" style="border: solid 1px #e5e5e5">
      <div class="detail-show" v-if="msg.title||msg.content">
        <el-form label-width="110px">
          <el-form-item label="发件人">
            <el-input type="input" :readonly="true" v-model="msg.send_user_name"></el-input>
          </el-form-item>
          <el-form-item label="发送时间">
            <el-input type="input" :readonly="true" v-model="msg.create_time"></el-input>
          </el-form-item>

          <el-form-item label="已读收件人" v-if="msg.read_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.read_user_names"></el-input>
          </el-form-item>
          <el-form-item label="未读收件人" v-if="msg.unread_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.unread_user_names"></el-input>
          </el-form-item>
          <el-form-item label="抄送" v-if="msg.copy_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.copy_user_names"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input type="input" :readonly="true" v-model="msg.title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <KfCkEditor type="textarea" :readonly="true" :rows="15" v-model="msg.content"></KfCkEditor>
          </el-form-item>
          <el-form-item label="附件" v-if="msg.appendix_objects && msg.appendix_objects.length > 0">
            <div class="doc-list">
              <div v-for="appendix in msg.appendix_objects" :key="appendix.id">
                <a :href="appendix.url">{{ appendix.originalName}}</a>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" v-if="msg.click_read == true">
            <el-button @click="setRead(msg.id)" :disabled="msg.currentRead">我已阅读完毕</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: "MsgReceive",
  data() {
    return {
      msg: {}
    }
  },
  methods: {
    rowChange(currentRow) {
      let msgId = currentRow?.msg_id
      if (!msgId) {
        return;
      }

      this.$axios.get('msg/getMsgDetail?msgId=' + msgId).then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.msg = res.data || {}
      }, error => {
        return this.$message.error(error.message)
      })
    },
    setRead(id) {
      if (!id) {
        return;
      }

      this.$axios.post('msg/setMsgRead', id).then(response => {
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.$message.success("提交成功")
        }
      }, error => {
        return this.$message.error(error.message)
      })
    },
    downloadFile(appendix) {
      let url = appendix?.active_ver?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    viewFile() {
      this.$store.dispatch('core/openWindow', {
        component: 'oa/ViewPdf',
        name: '文件查看',
        max: true
      })
    },
    getSendUserName(msg){
      return msg["name@send_user_id"]
    }
  }
}
</script>

<style lang="less" scoped>
.detail-show {
  padding: 15px 30px 5px 5px;
  min-height: 600px;
  word-break: break-all;
}

.doc-list {
  width: 100%;
  min-height: 100px;
}

</style>